import { render, staticRenderFns } from "./PartnerTransferTabTable.vue?vue&type=template&id=76985638"
import script from "./PartnerTransferTabTable.vue?vue&type=script&lang=js"
export * from "./PartnerTransferTabTable.vue?vue&type=script&lang=js"
import style0 from "./PartnerTransferTabTable.vue?vue&type=style&index=0&id=76985638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports